import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import CustomInput from '../../atoms/Inputs/CustomInput'
import PrimaryButton from '../../atoms/PrimaryButton'
import RadioBox from '../../atoms/RadioBox'
import axiosInstance from '../../../Utils/Utility/axiosconfig'
import './CheckoutPayment.css'
import Swal from 'sweetalert2'
import listpayment from '../../../Utils/API/selectcardpayment'
import getShippingAmount from '../../../Utils/API/shipstation'
import axios from 'axios'
import _ from 'lodash'
import { currencyFormat } from '../../../common/components'
import CustomSelect from '../../atoms/Inputs/CustomSelect'
import Popup from '../../../components/organisms/Popup/index'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Country from '../../../views/Signup/Country.json'
import State from '../../../views/Signup/State.json'
import Tooltip from '@material-ui/core/Tooltip'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import StripeNewCardForm from './StripeNewCardForm'
import { getStripePublishableKey } from '../../../Utils/stripekey'
import { getAuthToken } from '../../../Utils/Utility/auth'
const CheckoutPayment = (props) => {
    const history = useHistory()
    console.log('checkout propes --------', props)
    const [radvalue, setValue] = useState('nocard')
    const [selectedCard, setSelectedCard] = useState([])
    const [oldCard, setOldCard] = useState(0)
    const [cartTotal, setCartTotal] = useState(0)
    const [shipAmt, setShipAmt] = useState(0)
    const [loading, setLoading] = useState(false)
    const [selectAddress, setSelectAddress] = useState(0)
    const [get_all_address, setAlladress] = useState([])
    const [addAddressOpen, setAddAddressOpen] = useState(false)
    const [Country_code, setCountry] = useState(231)
    const [addressLoading, setAddressLoading] = useState(false)
    const [paymentmethode, setPaymentmethode] = useState('')
    const [selectedbank, setSelectedbank] = useState('')

    const stripeFormRef = useRef(null)
    const publishableKey = getStripePublishableKey()
    const stripePromise = useMemo(() => loadStripe(publishableKey), [publishableKey])

    const validationArray = Yup.object({
        // first_name: Yup.string()
        //     .trim()
        //     .matches(/^[0-9a-zA-Z]*$/g, 'Special characters not allowed')
        //     .max(250, 'Maximum 250 characters')
        //     .required('Required'),
        // last_name: Yup.string()
        //     .trim()
        //     .matches(/^[0-9a-zA-Z]*$/g, 'Special characters not allowed')
        //     .max(250, 'Maximum 250 characters')
        //     .required('Required'),
        // email: Yup.string()
        //     .email('Invalid email format')
        //     .max(250, 'Maximum 250 characters')
        //     .required('Required'),
        // phone: Yup.string()
        //     .trim()
        //     .matches(/^[0-9]*$/g, 'Only numbers are allowed')
        //     .min(10, 'Minimum 10 characters')
        //     .required('Required'),
        country: Yup.string().trim().required('Required'),
        state: Yup.string().trim().required('Required'),
        address: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        city: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z ]*$/g, 'Only characters allowed')
            .required('Required'),
        zipcode: Yup.string()
            .required('Required')
            .min(5, 'Minimum 5 digits required')
            .max(6, 'Maximum 6 digits only allowed'),
    })

    const formik = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            address: '',
            address1: '',
            country: 231,
            city: '',
            zipcode: '',
            state: 3919,
        },
        validationSchema: validationArray,
        onSubmit: async (values) => {
            setAddressLoading(true)
            const userData = JSON.parse(localStorage.getItem('userData'))
            values.first_name = userData.first_name
            values.last_name = userData.last_name
            values.email = userData.email
            values.phone = userData.phone
            values.country = Country.filter((x) => parseInt(x.id) == parseInt(Country_code))[0].name
            values.state = State.filter(
                (x) => parseInt(x.id) == parseInt(formik.values.state),
            )[0].name
            const { data } = await axiosInstance.post('mobileapi/add_shipping_address', values)

            try {
                if (data.success) {
                    allSvaedAdress()
                    setAddAddressOpen(false)
                    Swal.fire({
                        title: 'Address Added Successfully!!!',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                        position: 'center',
                    })
                    setAddressLoading(false)
                    formik.resetForm()
                } else {
                    setAddressLoading(false)
                }
            } catch (err) {
                console.log(err)
            }
        },
    })

    const listedcardPayment = async (data) => {
        const det = await listpayment(data, props.inv)
        console.log(det, 'resres')
        if (det === true) {
            Swal.fire({
                title: 'Successfully paid',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            window.location.href = '/dashboard?s=2'
            // history.push({
            //     pathname: '/dashboard',
            //     state: {
            //         value: 1,
            //     },
            // })
        } else {
            Swal.fire({
                title: 'Try Again later.',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
        }
    }

    useEffect(() => {
        allsavedCards()
        allSvaedAdress()
    }, [])

    useEffect(() => {
        if (paymentmethode == 'bank') {
            props.changetrasaction_fee()
        }
        if (paymentmethode == 'card') {
            props.changetrasaction_fee_card()
        }
    }, [paymentmethode])

    useEffect(() => {
        if (parseFloat(props.total_payable_amount) + parseFloat(props.ship_offer) > 1000) {
            Swal.fire({
                title: 'Due to the size of your invoice, Coins & Auctions Since 1994 will contact you directly with an invoice',
                icon: 'error',
                timer: 2500,
                showConfirmButton: false,
                position: 'center',
            })
            setTimeout(() => {
                window.location.href = '/dashboard?s=2'
            }, [1500])
        }
    }, [props.total_payable_amount])

    const shippingAmount = async () => {
        let params = {
            mode: process.env.REACT_APP_PAYMENTMODE, //process.env.REACT_APP_PAYMENT_MODE,
            fromzipcode: '98684',
            zipcode: props.profile.zip,
            weight: 10,
            height: 10,
        }
        const res = await getShippingAmount(params)
        console.log('getShippingAmount', params, res)
        setShipAmt(res.data.ship_rate)
        setLoading(false)
    }

    const allsavedCards = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('userData'))
            const res = await axiosInstance.post('mobileapi/stripe_pm_list', {
                user_id: userData?.id,
            })
            if (res?.data?.status === 'success') {
                res.data.data.responseData.data &&
                    setSelectedCard(
                        res.data.data.responseData.data.filter((data) => data.type == 'card'),
                    )
            } else {
                setSelectedCard([])
            }
        } catch (err) {
            console.log(err)
            setSelectedCard([])
        }
    }
    const allSvaedAdress = async () => {
        const { data } = await axiosInstance.get('mobileapi/get_all_shipping_address', {})

        try {
            // console
            if (data.success) {
                setAlladress(data.result.length ? data.result : [])
            } else {
                setAlladress([])
            }
        } catch (err) {
            console.log(err)
        }
    }
    // const savedCards = [
    //     { id: 1, cardNumber: '4132 1231 3212 2135', dateExp: '12/20', cardName: 'MasterCard' },
    //     { id: 2, cardNumber: '4132 1231 3212 2135', dateExp: '12/20', cardName: 'MasterCard' },
    // ]

    const handleChangeRadio = (data) => {
        console.log('event ==============', data)
        setValue(data.source)
    }
    const paynow = async () => {
        setLoading(true)
        const userData = JSON.parse(localStorage.getItem('userData'))
        const token = getAuthToken()
        if (parseInt(selectAddress) == 0) {
            setLoading(false)
            Swal.fire({
                title: 'Please Select Shipping Address',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }

        const continueCheckout = async (stripeBody) => {
            const body = {
                payment_details: stripeBody,
                invoice_id: props.invoice_id,
                shipping_addr_id: selectAddress,
                user_country: 'US',
                ship_local: props.ship_local,
                shipping_inside: 'yes',
                mode: process.env.REACT_APP_PAYMENTMODE,
                auction_io: 1,
                additional_amount: props.ship_offer,
            }
            const resData = await axios.post(
                `${process.env.REACT_APP_DOMAIN}mobileapi/successAfterPayAuction`,
                body,
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        domain: process.env.REACT_CONTROL_HUB_DOMAIN,
                    },
                },
            )
            if (resData.data.status === 'yes') {
                Swal.fire({
                    title: 'Successfully paid',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                window.location.href = '/dashboard?s=2'
            } else {
                setLoading(false)
                Swal.fire({
                    title: resData?.data?.message
                        ? resData.data.message
                        : resData?.data?.data?.error?.data?.message
                        ? resData.data.data.error.data.message
                        : '',
                    icon: 'error',
                    timer: 4500,
                    showConfirmButton: false,
                    position: 'center',
                })
            }
        }

        if (!userData?.card_paymentid) {
            var body_data = {
                account_id: process.env.REACT_APP_AUCTIONPAYKEY,
                name: userData?.first_name + ' ' + userData?.last_name,
                email: userData?.email,
                description: 'New Coins Customer',
                api_endpoint: '/api/customer/create',
                api_method: 'post',
            }
            const { data } = await axiosInstance.post('/api/auctionio_payment_api', body_data)

            if (data.status == 'success') {
                userData.card_paymentid = data.data.responseData.id
                localStorage.setItem('userData', JSON.stringify(userData))
                const { data_res } = await axiosInstance.post('auctionpay/save_customer_id', {
                    customer_id: userData.card_paymentid,
                })
            } else {
                Swal.fire({
                    title: data?.message || 'Something went wrong',
                    icon: 'error',
                    timer: 2500,
                    showConfirmButton: false,
                    position: 'center',
                })
                setLoading(false)
                return
            }
        }

        if (radvalue !== 'nocard') {
            const stripeBody = {
                source: radvalue,
                customer: userData.card_paymentid,
                currency: 'usd',
                description: 'Card checkout',
            }
            return continueCheckout(stripeBody)
        }

        if (!stripeFormRef.current) {
            setLoading(false)
            return
        }
        const { error, paymentMethod } = await stripeFormRef.current.createPaymentMethod()
        if (error) {
            setLoading(false)
            Swal.fire({
                title: error.message,
                icon: 'error',
                timer: 3000,
                showConfirmButton: false,
                position: 'center',
            })
            return
        }

        const stripeBody = {
            source: paymentMethod.id,
            customer: userData.card_paymentid,
            currency: 'usd',
            description: 'Amount paid from checkout page!',
        }
        return continueCheckout(stripeBody)
    }

    const bank_paynow = async () => {
        setLoading(true)
        const user = JSON.parse(localStorage.getItem('userData'))
        // var cardID = userData.card_paymentid ? userData.card_paymentid : ''
        const token = getAuthToken()
        if (parseInt(selectAddress) == 0) {
            setLoading(false)
            Swal.fire({
                title: 'Please Select Shipping Address',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }
        if (selectedbank == '') {
            setLoading(false)
            Swal.fire({
                title: 'Please Verify Bank Details or please select verified bank details',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }
        if (selectedbank == '') {
            setLoading(false)
            Swal.fire({
                title: 'Please Select Bank Details',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }

        if (props.total_payable_amount > props?.maxAmountLimit) {
            setLoading(false)
            Swal.fire({
                title: 'Please contact us directly to issue payment - (888) 655-COIN(2646).',
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }

        var data = {
            site_id: process.env.REACT_APP_SITE_ID,
            user_id: user.id ? user.id : '',
            payAmount: parseInt(
                parseFloat(
                    parseFloat(props.total_payable_amount) + parseFloat(props.ship_offer),
                ).toFixed(2) * 100,
            ),
        }

        const res = await axios.post(
            `${process.env.REACT_APP_DOMAIN}plugin/ach/stripe/payment/createBank`,
            data,
        )
        if (
            res.data.status == 'success' &&
            res.data.data.message.data.message == 'Payment successfully!'
        ) {
            var body = {
                invoice_id: props.invoice_id,
                transfer_id: res.data.data.message.data.responseData.id,
                shipping_addr_id: selectAddress,
                transaction_fee_per: parseInt(props.trasaction_per_fee),
                additional_amount: props.ship_offer,
            }
            const resData = await axios.post(
                `${process.env.REACT_APP_DOMAIN}mobileapi/successAfterPayAuction__updatebank`,
                body,
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        domain: process.env.REACT_CONTROL_HUB_DOMAIN,
                    },
                },
            )
            if (resData.data.status == 'yes') {
                Swal.fire({
                    title: 'Payment successful!',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'center',
                })
                // history.push({
                //     pathname: '/dashboard',
                //     state: {
                //         value: 1,
                //     },
                // })
                window.location.href = '/dashboard?s=2'
                return false
            } else {
                Swal.fire({
                    title: resData?.data?.message
                        ? resData.data.message
                        : resData?.data?.data?.error?.data?.message
                        ? resData.data.data.error.data.message
                        : '',
                    icon: 'error',
                    timer: 4500,
                    showConfirmButton: false,
                    position: 'center',
                })
                return false
            }
        } else {
            Swal.fire({
                title: res.data.data.message,
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                position: 'center',
            })
            return false
        }
    }

    return (
        <div className="paymentDetails">
            <div className="paymentTotal">
                <div className="won_amount d-flex justify-content-between">
                    <p className="totalTitle">Won Amount: </p>
                    <p className="won_amount">{currencyFormat(props.amount)}</p>
                </div>
                {parseFloat(props.buyers_premium) > 0 ? (
                    <div className="admin_amount_1 d-flex justify-content-between">
                        <p className="totalTitle">Buyer's Premium:</p>
                        <p className="additional_amount_1">
                            {currencyFormat(props.buyers_premium)}
                        </p>
                    </div>
                ) : (
                    ''
                )}
                {parseFloat(props.sales_tax) > 0 ? (
                    <div className="admin_amount_2 d-flex justify-content-between">
                        <p className="totalTitle">Sales Tax:</p>
                        <p className="additional_amount_2">{currencyFormat(props.sales_tax)}</p>
                    </div>
                ) : (
                    ''
                )}
                {parseFloat(props.transaction_fee) > 0 ? (
                    <div className="admin_amount_3 d-flex justify-content-between">
                        <p className="totalTitle">
                            Credit Card Fee:{' '}
                            {/* <Tooltip
                                placement="top"
                                title={
                                    <div
                                        style={{
                                            // width: '300px',
                                            // padding: '5px',
                                            fontSize: '16px',
                                            lineHeight: '24px',
                                        }}
                                    >
                                        Feeless ACH/Bank Transfer Also Available.
                                    </div>
                                }
                                arrow
                            >
                                <span className="material-icons">info</span>
                            </Tooltip> */}
                        </p>
                        <p className="additional_amount_3">
                            {currencyFormat(props.transaction_fee)}
                        </p>
                    </div>
                ) : (
                    ''
                )}

                {parseInt(props.shipping_fee) > 0 ? (
                    <div className="admin_amount_3 d-flex justify-content-between">
                        <p className="totalTitle">Shipping Amount:</p>
                        <p className="additional_amount_3">{currencyFormat(props.shipping_fee)}</p>
                    </div>
                ) : (
                    <div className="admin_amount_3 d-flex justify-content-between">
                        <p className="totalTitle">Shipping:</p>
                        <p className="additional_amount_3">FREE</p>
                    </div>
                )}

                {parseInt(props.ship_offer) > 0 ? (
                    <div className="totalAmount d-flex justify-content-between">
                        <p className="totalTitle">Additional Amount:</p>
                        <p className="additional_amount_3">{currencyFormat(props.ship_offer)}</p>
                    </div>
                ) : (
                    ''
                )}

                <div className="totalAmount d-flex justify-content-between">
                    <p className="totalTitle">Item Total:</p>
                    <p className="totalPrice">
                        {currencyFormat(
                            parseFloat(props.total_payable_amount) + parseFloat(props.ship_offer),
                        )}
                    </p>
                </div>
                {/* <div className="convenienceAmount d-flex justify-content-between">
                        <p className="convenienceTitle">Convenience Fee 3%</p>
                        <p className="convenienceFee">:{props.conFee}</p>
                    </div>
                    <div className="taxAmount d-flex justify-content-between">
                        <p className="taxTitle">Tax 0%</p>
                        <p className="taxPrice">:{props.taxPrice}</p>
                    </div>
                    <div className="grandTotal d-flex justify-content-between">
                        <p className="grandTitle">GrandTotal</p>
                        <p className="grandPrice">:{props.grandTotal}</p>
                    </div> */}
            </div>
            <h2 className="paymentTitle my-3 mt-5">Shipping Address</h2>
            <div className="od-box">
                <CustomSelect
                    //label={'Select Shipping Address'}
                    value={selectAddress}
                    onChange={(e) => setSelectAddress(e.target.value)}
                >
                    <option value={0}>Select Shipping Address</option>
                    {get_all_address.map((val) => (
                        <option value={val.id}>
                            {val.address +
                                ', ' +
                                val.country +
                                ', ' +
                                val.state +
                                ', ' +
                                val.city +
                                ', ' +
                                val.zipcode}
                        </option>
                    ))}
                </CustomSelect>
                <div className="form-group mt-2">
                    {/* <button
                        type="submit"
                        className="pink-btn"
                        // onClick={() => setAddAddressOpen(true)}
                    >
                        Add Address
                    </button> */}
                    <PrimaryButton
                        label={'Add New Address'}
                        onClick={() => setAddAddressOpen(true)}
                    />
                </div>
            </div>
            <h2 className="paymentTitle my-3 mt-5">Payment Method</h2>
            <div className="od-box">
                <CustomSelect
                    //label={'Select Shipping Address'}
                    value={
                        paymentmethode == 'card' || paymentmethode == '' ? 'card' : paymentmethode
                    }
                    onChange={(e) => setPaymentmethode(e.target.value)}
                >
                    <option value={'card'}>Credit Card</option>
                    {/* <option value={'bank'}>ACH/Bank</option> */}
                </CustomSelect>
            </div>
            <div className="paymentCard mt-5">
                {paymentmethode == 'card' || paymentmethode == '' ? (
                    <>
                        <div className="exsitingCard">
                            <div className="numRadio">
                                <RadioBox
                                    items={selectedCard}
                                    value={radvalue}
                                    //onchange={handleChangeRadio}
                                    name="savedcards"
                                    int={1}
                                    checkout={true}
                                    cc={handleChangeRadio}
                                />
                                {/* {console.log(radvalue, 'radvalueeeeeeeeeee')} */}
                            </div>
                        </div>
                        {radvalue === 'nocard' && (
                            <div className="cardText mt-3">
                                {publishableKey ? (
                                    <Elements stripe={stripePromise}>
                                        <StripeNewCardForm ref={stripeFormRef} />
                                    </Elements>
                                ) : (
                                    <p>Invalid Stripe publishable key configuration.</p>
                                )}
                            </div>
                        )}
                        {
                            <PrimaryButton
                                label={loading ? 'Loading' : 'Pay'}
                                disabled={loading}
                                onClick={paynow}
                            />
                        }
                    </>
                ) : (
                    <>
                        {/* <Cards
                            cc_id={(id) => setSelectedbank(id)}
                            from="checkout"
                            selectedbank={selectedbank}
                        />
                        {
                            <PrimaryButton
                                label={loading ? 'Loading' : 'Pay'}
                                disabled={loading}
                                onClick={bank_paynow}
                            />
                        } */}
                    </>
                )}
            </div>
            <Popup
                modaltitle="Add New Address"
                open={addAddressOpen}
                handleClose={() => setAddAddressOpen(false)}
            >
                <div className="paymentCard_static payAdrsPopup">
                    <div className="cardText">
                        <CustomInput
                            label="Address Line 1*"
                            variant="standard"
                            value={formik.values.address}
                            name="address"
                            onChange={formik.handleChange}
                        />
                        <div className="errorMessage-1 errorTxt">
                            {formik.errors.address && formik.touched.address
                                ? formik.errors.address
                                : ''}
                        </div>
                        <CustomInput
                            label="Address Line 2*"
                            variant="standard"
                            value={formik.values.address1}
                            name="address1"
                            onChange={formik.handleChange}
                        />
                        <div className="errorMessage-1 errorTxt">
                            {formik.errors.address1 ? formik.errors.address1 : ''}
                        </div>
                        <div className="cardExpiry d-flex justify-content-between my-3">
                            <div className="w-100 mr-2">
                                <CustomSelect
                                    // label={'Country'}
                                    name="country"
                                    value={formik.values.country}
                                    onChange={(e) => {
                                        setCountry(e.target.value)
                                        formik.handleChange(e)
                                    }}
                                >
                                    {Country.map((val) => (
                                        <option value={val.id}>{val.name}</option>
                                    ))}
                                </CustomSelect>
                                <div className="errorMessage-1 errorTxt">
                                    {formik.errors.country && formik.touched.country
                                        ? formik.errors.country
                                        : ''}
                                </div>
                            </div>
                            <div className="w-100 ml-2">
                                <CustomSelect
                                    // label={'State'}
                                    value={formik.values.state}
                                    onChange={formik.handleChange}
                                    name="state"
                                >
                                    {State.filter(
                                        (x) => parseInt(x.country_id) == parseInt(Country_code),
                                    ).map((val) => (
                                        <option value={val.id}>{val.name}</option>
                                    ))}
                                </CustomSelect>
                                <div className="errorMessage-1 errorTxt">
                                    {formik.errors.state && formik.touched.state
                                        ? formik.errors.state
                                        : ''}
                                </div>
                            </div>
                        </div>
                        <div className="cardExpiry d-flex justify-content-between ">
                            <div className="w-100 mr-2">
                                <CustomInput
                                    label="City*"
                                    variant="standard"
                                    value={formik.values.city}
                                    name="city"
                                    onChange={formik.handleChange}
                                />
                                <div className="errorMessage-1 errorTxt">
                                    {formik.errors.city && formik.touched.city
                                        ? formik.errors.city
                                        : ''}
                                </div>
                            </div>
                            <div className="w-100 ml-2">
                                <CustomInput
                                    label="Zip*"
                                    variant="standard"
                                    value={formik.values.zipcode}
                                    name="zipcode"
                                    onChange={formik.handleChange}
                                />
                                <div className="errorMessage-1 errorTxt">
                                    {formik.errors.zipcode && formik.touched.zipcode
                                        ? formik.errors.zipcode
                                        : ''}
                                </div>
                            </div>
                        </div>
                        <div className="form-group mt-2">
                            <PrimaryButton
                                disabled={addressLoading}
                                label={'Add Address'}
                                onClick={formik.handleSubmit}
                            />
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
    )
}

export default CheckoutPayment
